import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.machine.communication');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-machine-communication',
template: templateSource || '',
    styles: [``],
})
export class PortalMachineCommunicationComponent implements OnInit {
    @Input() data: any = { machine: false, env: false };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }
}

export default PortalMachineCommunicationComponent;